import store from '@shared/store/index';

export function callScannerInnerPage(compareCoin){
  return;
  store.dispatch('Scanner/initScanner', { initCoin: compareCoin });
}